import { createContext } from 'react';
import { ProviderEntity } from '../../../models/provider';

export type SelectedProviderStore = { selectedProvider: ProviderEntity };

export const SelectedProviderContext = createContext<SelectedProviderStore | null>(null);
